import { sendAnalyticsEvent, useSession } from '@faststore/sdk'
import { useEffect, useState } from 'react'
import { BK_ID_STORAGE_KEY } from 'src/sdk/session/validate'
import { GTMUserEvent } from '../types'

export const getPersonHashPromise = (email: string | undefined) => {
  return new Promise<string | null>((resolve, reject) => {
    try {
      if (!email) {
        resolve(null)
      } else {
        const trimmed = email.trim()?.toLowerCase()
        const msgBuffer = new TextEncoder().encode(trimmed)

        crypto.subtle
          .digest('SHA-256', msgBuffer)
          .then((hashBuffer) => {
            const hashArray = Array.from(new Uint8Array(hashBuffer))
            const hashHex = hashArray
              .map((b) => b.toString(16).padStart(2, '0'))
              .join('')

            resolve(hashHex)
          })
          .catch((error) => {
            reject(error)
          })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const useUserEvent = (pageType: string) => {
  const { person, isValidating } = useSession()
  const [hasSentEvent, setHasSentEvent] = useState<boolean>(false)

  useEffect(() => {
    if (!hasSentEvent && !isValidating) {
      const bkId = JSON.parse(
        localStorage.getItem(BK_ID_STORAGE_KEY) || '{}'
      )?.bk_id

      getPersonHashPromise(person?.email).then((hashedEmail) => {
        sendAnalyticsEvent<GTMUserEvent>({
          name: 'userData',
          params: {
            loginStatus: person?.id ? 'logged' : 'not logged',
            userID: person?.id ? bkId ?? person?.id : undefined,
            ...(person?.id && bkId && { bk_account_id: bkId }),
            ...(person?.id && { vtex_user_id: person?.id }),
            ...(hashedEmail && { emailHash: hashedEmail }),
            visitorType: undefined,
            visitorContactInfo: {
              hashed_email: hashedEmail ?? undefined,
            },
            visitorOptinNewsLetter: undefined,
            pageType,
          },
        })

        setHasSentEvent(true)
      })
    }
  }, [
    person,
    setHasSentEvent,
    hasSentEvent,
    isValidating,
    getPersonHashPromise,
  ])
}
